import PropTypes from "prop-types"
import styled from "styled-components"
import { headlineTextTheme } from "../../theme"
import { fontBold } from "../../utils/fontFamily"

const H1 = styled.h1`
  color: ${({ whiteText }) => (whiteText ? "#ffff" : headlineTextTheme)};
  ${fontBold()}
  line-height: 1.5;
  
  ${({ theme }) => theme.se`
   font-size: 30px;
  `}

  ${({ theme }) => theme.tablet`
   font-size: 36px;
  `}

  ${({ theme }) => theme.desktop`
   font-size: 40px;
  `}
`

H1.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  whiteText: PropTypes.bool,
}

H1.defaultProps = {
  whiteText: false,
}

export default H1
